import { Typography } from 'antd';
import React from 'react';
const { Paragraph } = Typography;
interface PageSectionProps {
  heading: string;
  description?: React.ReactNode | string;
  children?: React.ReactNode;
}
export default function PageSection({
  children,
  heading,
  description,
}: PageSectionProps) {
  return (
    <section style={{ marginTop: '20px' }}>
      <Typography.Title
        className="page-sub-heading"
        level={5}
        style={{ marginBottom: 0 }}
      >
        {heading}
      </Typography.Title>
      <Paragraph italic type="secondary" style={{ fontSize: '12px' }}>
        {description}
      </Paragraph>
      {children}
    </section>
  );
}
